import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { IntelligenceView } from '@/app/intelligence-audience/lib/intelligence-view';

/**
 * The audience — and, for an internal user, the client — last open on the Intelligence page,
 * so the way back from a profile, another tab or onboarding returns to it rather than to the
 * House default. Kept in `sessionStorage` (NPJB-814): a reload mid-onboarding must still exit
 * to the client it was entered for, and the URLs there carry none. It dies with the tab, and
 * `viewFor` drops another login's view.
 */
interface IntelligenceViewState {
  view: IntelligenceView | null;
  remember: (view: IntelligenceView) => void;
}

export const useIntelligenceViewStore = create<IntelligenceViewState>()(
  persist(
    (set) => ({
      view: null,
      remember: (view) => set({ view }),
    }),
    {
      name: 'intelligence-view-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
